import { CustomSelectFieldProps, SelectField } from 'components/form'
import { JustificativaNaoPossuiCpfEnum } from 'graphql/types.generated'

export const justificativaNaoPossuiCpfRecord: Record<JustificativaNaoPossuiCpfEnum, string> = {
  DOCUMENTO_PERDIDO: 'Documento perdido',
  INCONSCIENTE_OU_SEM_LUCIDEZ: 'Paciente desacordado, sem documentos',
  RECEM_NASCIDO_SEM_REGISTRO: 'Recém-nascidos',
  MEMBRO_COMUNIDADE_AFASTADA: 'Indígenas sem CPF',
  SITUACAO_DE_RUA: 'Pessoa em situação de rua sem documentos',
  RECUSA_CULTURA_OU_RELIGIOSA: 'Recusa por cultura ou religião',
  ESTRANGEIRO: 'Estrangeiro em trânsito (turista/visitante)',
  PESSOA_INDOCUMENTADA: 'Pessoa indocumentada',
  CRIANCAS_SEM_DOCUMENTACAO_EMITIDA: 'Crianças sem documentação emitida',
  ESTRANGEIRO_RESIDENTE_SEM_CPF: 'Estrangeiro residente sem CPF',
  INTERNACAO_COMPULSORIA: 'Internação compulsória (saúde mental ou ordem judicial)',
  POPULACAO_MIGRANTE_REFUGIADA_EM_REGULARIZACAO: 'População migrante/refugiada em processo de regularização',
  SITUACOES_CALAMIDADE_DESASTRE: 'Situações de calamidade ou desastre',
  OUTRA: 'Outra',
}

export const justificativasNaoPossuiCpfValidas: JustificativaNaoPossuiCpfEnum[] = [
  JustificativaNaoPossuiCpfEnum.INCONSCIENTE_OU_SEM_LUCIDEZ,
  JustificativaNaoPossuiCpfEnum.RECEM_NASCIDO_SEM_REGISTRO,
  JustificativaNaoPossuiCpfEnum.MEMBRO_COMUNIDADE_AFASTADA,
  JustificativaNaoPossuiCpfEnum.SITUACAO_DE_RUA,
  JustificativaNaoPossuiCpfEnum.RECUSA_CULTURA_OU_RELIGIOSA,
  JustificativaNaoPossuiCpfEnum.ESTRANGEIRO,
  JustificativaNaoPossuiCpfEnum.PESSOA_INDOCUMENTADA,
  JustificativaNaoPossuiCpfEnum.CRIANCAS_SEM_DOCUMENTACAO_EMITIDA,
  JustificativaNaoPossuiCpfEnum.ESTRANGEIRO_RESIDENTE_SEM_CPF,
  JustificativaNaoPossuiCpfEnum.INTERNACAO_COMPULSORIA,
  JustificativaNaoPossuiCpfEnum.POPULACAO_MIGRANTE_REFUGIADA_EM_REGULARIZACAO,
  JustificativaNaoPossuiCpfEnum.SITUACOES_CALAMIDADE_DESASTRE,
]

export type JustificativaNaoPossuiCpfSelectFieldProps = CustomSelectFieldProps<JustificativaNaoPossuiCpfEnum>

export function JustificativaNaoPossuiCpfSelectField(props: JustificativaNaoPossuiCpfSelectFieldProps) {
  const itemToString = (item: JustificativaNaoPossuiCpfEnum) => item && justificativaNaoPossuiCpfRecord[item]

  return (
    <SelectField<JustificativaNaoPossuiCpfEnum>
      items={justificativasNaoPossuiCpfValidas}
      itemToString={itemToString}
      {...props}
    />
  )
}
